import { useTranslation } from "react-i18next";

const ChapterGenerationStatus = ({
  status,
  onGoToPrevious,
}: {
  status: "generating" | "queued" | "requires_previous";
  onGoToPrevious?: () => void;
}) => {
  const { t } = useTranslation();
  if (status === "generating") {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
        <div className="relative mb-6">
          <div className="w-16 h-16 rounded-full border-2 border-[var(--accent)]/30 border-t-[var(--accent)] animate-spin" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-2xl">✍️</span>
          </div>
        </div>
        <h3 className="text-lg font-semibold text-current mb-2">
          {t("chapterGeneration.writing")}
        </h3>
        <p className="text-sm text-current opacity-60 max-w-sm">
          {t("chapterGeneration.writingDesc")}
        </p>
        {/* Skeleton text lines */}
        <div className="mt-8 w-full max-w-lg space-y-3">
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="skeleton h-4"
              style={{
                width: `${70 + Math.random() * 30}%`,
              }}
            />
          ))}
        </div>
      </div>
    );
  }

  if (status === "queued") {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
        <span className="text-4xl mb-4">📋</span>
        <h3 className="text-lg font-semibold text-current mb-2">
          {t("chapterGeneration.queued")}
        </h3>
        <p className="text-sm text-current opacity-60 max-w-sm">
          {t("chapterGeneration.queuedDesc")}
        </p>
      </div>
    );
  }

  if (status === "requires_previous") {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
        <span className="text-4xl mb-4">🔒</span>
        <h3 className="text-lg font-semibold text-current mb-2">
          {t("chapterGeneration.requiresPrevious")}
        </h3>
        <p className="text-sm text-current opacity-60 max-w-sm mb-6">
          {t("chapterGeneration.requiresPreviousDesc")}
        </p>
        {onGoToPrevious && (
          <button
            onClick={onGoToPrevious}
            className="px-6 py-3 rounded-full bg-[var(--accent)] text-[var(--text-inverse)] font-medium active:scale-95 transition-transform shadow-[0_0_15px_var(--accent-glow)]"
          >
            {t("chapterGeneration.goToPrevious")}
          </button>
        )}
      </div>
    );
  }

  return null;
};

export default ChapterGenerationStatus;
